<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-s-order"></i> 门店销售单
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <div class="search-row">
          <div class="search-item">
            <span class="search-label">门店名称/手机号</span>
            <el-input 
              v-model="searchForm.shop_name" 
              placeholder="请输入门店名称或手机号"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="search-input"
            ></el-input>
          </div>
          <div class="search-item">
            <span class="search-label">支付状态</span>
            <el-select 
              v-model="searchForm.pay_status" 
              placeholder="请选择支付状态"
              clearable
              size="small"
              class="status-select"
            >
              <el-option label="已支付" value="2"></el-option>
              <el-option label="未支付" value="0"></el-option>
            </el-select>
          </div>
          <div class="search-item date-item">
            <span class="search-label">下单日期</span>
            <el-date-picker
              v-model="searchForm.start_end_date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
              class="date-picker"
            ></el-date-picker>
          </div>
          <div class="search-actions">
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search" size="small">搜索</el-button>
            <el-button @click="resetSearch" icon="el-icon-refresh-right" size="small">重置</el-button>
            <el-button type="success" @click="addData" icon="el-icon-plus" size="small">新增销售单</el-button>
            <el-button type="warning" @click="exportExcel" icon="el-icon-download" size="small">导出</el-button>
          </div>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total"><i class="el-icon-document"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">销售单总数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon amount"><i class="el-icon-money"></i></div>
          <div class="stat-info">
            <div class="stat-value">¥{{ totalAmount }}</div>
            <div class="stat-label">总销售金额</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon paid"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ paidCount }}</div>
            <div class="stat-label">已支付订单</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon unpaid"><i class="el-icon-close"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ unpaidCount }}</div>
            <div class="stat-label">未支付订单</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          show-summary
          :summary-method="getSummaries"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
          
          <el-table-column label="销售信息" min-width="200">
            <template slot-scope="scope">
              <div class="order-info">
                <div class="order-sn">
                  <i class="el-icon-document"></i>
                  <span>单号：{{ scope.row.sn }}</span>
                </div>
                <div class="order-source" v-if="scope.row.bom">
                  <i class="el-icon-s-promotion"></i>
                  <span>来源：{{ scope.row.bom.title }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="门店信息" min-width="180">
            <template slot-scope="scope">
              <div class="shop-info">
                <div class="shop-name">
                  <i class="el-icon-shop"></i>
                  <span>{{ scope.row.shop ? scope.row.shop.name : '-' }}</span>
                </div>
                <div class="shop-contact" v-if="scope.row.shop">
                  <i class="el-icon-phone"></i>
                  <span>{{ scope.row.shop.mobile || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="金额信息" width="140" align="center">
            <template slot-scope="scope">
              <div class="amount-info">
                <div class="amount">
                  <span class="label">金额：</span>
                  <span class="value">¥{{ scope.row.order_amount }}</span>
                </div>
                <div class="type">
                  <el-tag :type="getOrderTypeTag(scope.row.type)" size="small" effect="plain">
                    {{ scope.row.type | typeFilter }}
                  </el-tag>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="下单时间" width="160" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="支付状态" width="160" align="center">
            <template slot-scope="scope">
              <div class="pay-status">
                <el-tag :type="scope.row.pay_status == 2 ? 'success' : 'danger'" size="small">
                  {{ scope.row.pay_status == 2 ? '已支付' : '未支付' }}
                </el-tag>
                <div v-if="scope.row.pay_time" class="pay-time">{{ scope.row.pay_time | dateFormat }}</div>
                <div v-if="scope.row.pay_order_sn" class="pay-sn">{{ scope.row.pay_order_sn }}</div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="销售人" width="120" align="center">
            <template slot-scope="scope">
              <div class="seller-info">
                <i class="el-icon-user"></i>
                <span>{{ scope.row.employee ? scope.row.employee.name_cn : '-' }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="140" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="detail-btn" @click="goInfo(scope.row)">
                <i class="el-icon-view"></i> 详情
              </el-button>
              <el-button type="text" size="small" class="edit-btn" @click="goEdit(scope.row)">
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-s-order"></i>
        <p>暂无销售单数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑弹框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogFormVisible" 
      width="600px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="handleDialogClosed"
    >
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="110px" label-position="right" size="small">
          <el-form-item label="选择门店" prop="shop_id">
            <el-select v-model="form.shop_id" placeholder="请选择门店" filterable clearable style="width: 100%;">
              <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="来源单号" prop="bom_id">
            <el-select v-model="form.bom_id" placeholder="请选择来源单" filterable clearable style="width: 100%;">
              <el-option v-for="item in bomList" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="销售单号" prop="sn">
            <el-input v-model="form.sn" placeholder="请输入销售单号" prefix-icon="el-icon-document" clearable></el-input>
          </el-form-item>

          <el-form-item label="销售金额" prop="order_amount">
            <el-input-number v-model="form.order_amount" :min="0" :precision="2" controls-position="right" style="width: 100%;"></el-input-number>
          </el-form-item>

          <el-form-item label="订单类型" prop="type">
            <el-select v-model="form.type" placeholder="请选择订单类型" style="width: 100%;">
              <el-option label="诊疗订单" :value="1"></el-option>
              <el-option label="挂号订单" :value="2"></el-option>
              <el-option label="优惠券" :value="3"></el-option>
              <el-option label="收款订单" :value="4"></el-option>
              <el-option label="兑换订单" :value="5"></el-option>
              <el-option label="一元购" :value="6"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="销售人" prop="employee_id">
            <el-select v-model="form.employee_id" placeholder="请选择销售人" filterable clearable style="width: 100%;">
              <el-option v-for="item in employeeList" :key="item.id" :label="item.name_cn" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付状态" prop="pay_status">
            <el-select v-model="form.pay_status" placeholder="请选择支付状态" style="width: 100%;">
              <el-option label="未支付" :value="0">
                <span style="color: #ff4d4f;">● 未支付</span>
              </el-option>
              <el-option label="已支付" :value="2">
                <span style="color: #00b578;">● 已支付</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="form.remark" placeholder="请输入备注信息" :rows="3" maxlength="200" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import * as XLSX from 'xlsx'  // 添加这行
export default {
  name: "sellList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        shop_name: "",
        pay_status: "",
        start_end_date: ""
      },
      
      // 统计数据
      totalAmount: 0,
      paidCount: 0,
      unpaidCount: 0,
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      // 下拉列表
      shopList: [],
      bomList: [],
      employeeList: [],
      
      // 弹框控制
      dialogFormVisible: false,
      dialogTitle: '',
      
      // 表单数据
      form: {
        id: '',
        shop_id: '',
        bom_id: '',
        sn: '',
        order_amount: 0,
        type: 1,
        employee_id: '',
        pay_status: 0,
        remark: ''
      },
      
      // 验证规则
      rules: {
        shop_id: [{ required: true, message: '请选择门店', trigger: 'change' }],
        order_amount: [{ required: true, message: '请输入销售金额', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.DataList()
    this.getShopList()
    this.getEmployeeList()
  },
  filters: {
    dateFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss")
    },
    typeFilter(type) {
      const map = { 1: '诊疗订单', 2: '挂号订单', 3: '优惠券', 4: '收款订单', 5: '兑换订单', 6: '一元购' }
      return map[type] || '-'
    }
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() { return { cursor: 'pointer' } },
    
    getOrderTypeTag(type) {
      const map = { 1: 'primary', 2: 'success', 3: 'info', 4: 'warning', 5: 'danger', 6: '' }
      return map[type] || 'info'
    },
    
    calculateStats() {
      if (!this.tableLoadData.length) {
        this.totalAmount = 0
        this.paidCount = 0
        this.unpaidCount = 0
        return
      }
      this.totalAmount = this.tableLoadData.reduce((sum, item) => sum + (parseFloat(item.order_amount) || 0), 0).toFixed(2)
      this.paidCount = this.tableLoadData.filter(item => item.pay_status == 2).length
      this.unpaidCount = this.tableLoadData.filter(item => item.pay_status != 2).length
    },
    
    resetSearch() {
      this.searchForm = { shop_name: "", pay_status: "", start_end_date: "" }
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    getShopList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id')
      }
      this.$axios.findShopList(param).then(res => {
        if (res.code == 200) this.shopList = res.data || []
      })
    },
    
    getBomList(shopId) {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        shop_id: shopId
      }
      this.$axios.findBomList(param).then(res => {
        if (res.code == 200) this.bomList = res.data || []
      })
    },
    
    getEmployeeList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.employeeList(param).then(res => {
        if (res.code == 200) this.employeeList = res.data || []
      })
    },
    
    indexMethod(index) { return (this.pageNum - 1) * this.pageSize + index + 1 },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.searchForm.shop_name) param.shop_name = this.searchForm.shop_name
      if (this.searchForm.pay_status) param.pay_status = this.searchForm.pay_status
      if (this.searchForm.start_end_date && this.searchForm.start_end_date.length === 2) {
        param.start_time = this.searchForm.start_end_date[0]
        param.end_time = this.searchForm.start_end_date[1]
      }
      
      this.$axios.findHisOrderSellListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.property === 'order_amount') {
          const total = data.reduce((prev, curr) => prev + (parseFloat(curr.order_amount) || 0), 0)
          sums[index] = `¥${total.toFixed(2)}`
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    
    addData() {
      this.dialogTitle = '新增销售单'
      this.form = {
        id: '',
        shop_id: '',
        bom_id: '',
        sn: '',
        order_amount: 0,
        type: 1,
        employee_id: '',
        pay_status: 0,
        remark: ''
      }
      this.dialogFormVisible = true
    },
    
    goEdit(row) {
      this.dialogTitle = '编辑销售单'
      this.form = {
        id: row.id,
        shop_id: row.shop_id,
        bom_id: row.bom_id,
        sn: row.sn,
        order_amount: row.order_amount,
        type: row.type,
        employee_id: row.employee_id,
        pay_status: row.pay_status,
        remark: row.remark || ''
      }
      this.dialogFormVisible = true
    },
    
    goInfo(row) {
      this.$router.push({ path: '/sellInfo', query: { id: row.id } })
    },
    
    handleDialogClosed() { this.$refs.formRef?.resetFields() },
    cancelForm() { this.dialogFormVisible = false },
    
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const param = {
            ...this.form,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token')
          }
          const api = this.form.id ? this.$axios.updateSellOrder : this.$axios.saveSellOrder
          api(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.dialogFormVisible = false
              this.DataList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    
    exportExcel() {
      if (!this.tableLoadData.length) {
        this.$message.warning('暂无数据可导出')
        return
      }
      const exportData = this.tableLoadData.map((row, index) => ({
        '序号': index + 1,
        '销售单号': row.sn,
        '门店名称': row.shop?.name || '--',
        '门店手机': row.shop?.mobile || '--',
        '销售金额': row.order_amount,
        '订单类型': this.$options.filters.typeFilter(row.type),
        '销售人': row.employee?.name_cn || '--',
        '支付状态': row.pay_status == 2 ? '已支付' : '未支付',
        '下单时间': moment(row.add_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
        '支付时间': row.pay_time ? moment(row.pay_time * 1000).format('YYYY-MM-DD HH:mm:ss') : '--'
      }))
      const worksheet = XLSX.utils.json_to_sheet(exportData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '门店销售单')
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `门店销售单_${moment().format('YYYYMMDDHHmmss')}.xlsx`
      link.click()
      URL.revokeObjectURL(link.href)
      this.$message.success('导出成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
  }
  
  .search-item {
    display: flex;
    align-items: center;
    gap: 8px;
    .search-label { font-size: 13px; color: #606266; white-space: nowrap; min-width: 100px; text-align: right; }
    .search-input, .status-select { width: 180px; }
    .date-picker { width: 260px; }
  }
  
  .search-actions {
    display: flex;
    gap: 10px;
    margin-left: auto;
    .el-button { border-radius: 20px; padding: 8px 18px; }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; } }
    .el-button--warning { background: #e6a23c; border-color: #e6a23c; &:hover { background: #ebb563; } }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 140px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 16px 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.amount { background: linear-gradient(135deg, #ffb980, #ffd666); }
      &.paid { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.unpaid { background: linear-gradient(135deg, #ff4d4f, #ff7875); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.order-info, .shop-info, .amount-info { .order-sn, .shop-name, .amount { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { color: #1677ff; } span { font-weight: 500; } } .order-source, .shop-contact { display: flex; align-items: center; gap: 6px; i { color: #8c8f98; font-size: 12px; } span { font-size: 12px; color: #8c8f98; } } }

.seller-info { display: flex; align-items: center; gap: 6px; justify-content: center; i { color: #00b578; } }
.pay-status { .pay-time, .pay-sn { font-size: 11px; color: #8c8f98; margin-top: 2px; } }

.detail-btn { color: #909399; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #a6a9ad; } }
.edit-btn { color: #1677ff; i { margin-right: 4px; } &:hover { color: #4096ff; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pagination .el-pager li.active { background: #1677ff; color: #fff; } }

// 弹框样式
.alipay-dialog .el-dialog {
  border-radius: 20px; overflow: hidden; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header { background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%); padding: 20px 24px; .el-dialog__title { color: #fff; font-size: 18px; font-weight: 500; } }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 16px 24px 24px; border-top: 1px solid #f0f0f0; }
}

.dialog-footer { display: flex; justify-content: flex-end; gap: 12px; .el-button { border-radius: 20px; padding: 9px 24px; } .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; } } }

@media (max-width: 1200px) {
  .search-bar .search-item .search-input,
  .search-bar .search-item .status-select { width: 150px; }
  .search-bar .search-item .date-picker { width: 220px; }
}
</style>